import { createUseStyles } from 'react-jss';
const usePoweredByRevertStyles = createUseStyles((theme) => ({
    a: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        maxHeight: '13px'
    },
    icon: { scale: '0.7' },
    text: {
        fontSize: '12px',
        lineHeight: '16px',
        color: theme.colors.grey[2]
    }
}));
export default usePoweredByRevertStyles;
